import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Contact from './components/Contact/Contact';
import OurServices from './components/OurServices/OurServices';
import FacilitiesManagement from './components/OurServices/FacilitiesManagement';
import InformationTechnology from './components/OurServices/InformationTechnology';
import GRC from './components/OurServices/GRC';
import ProgramManagement from './components/OurServices/ProgramManagement';
import RealProperty from './components/OurServices/RealProperty';
import CapabilityStatement from './components/About/CapabilityStatement';
import LeadershipTeam from './components/About/LeadershipTeam';
import NAICSCodes from './components/About/NAICSCodes';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<OurServices />} />
          <Route path="/services/facilities" element={<FacilitiesManagement />} />
          <Route path="/services/it" element={<InformationTechnology />} />
          <Route path="/services/grc" element={<GRC />} />
          <Route path="/services/pm-pmo" element={<ProgramManagement />} />
          <Route path="/services/real-property" element={<RealProperty />} />
          <Route path="/about/capability-statement" element={<CapabilityStatement />} />
          <Route path="/about/leadership-team" element={<LeadershipTeam />} />
          <Route path="/about/naics-codes" element={<NAICSCodes />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
